const installFormData = {
  "size": "medium",
  "span": 24,
  "column": 2,
  "fields": [
    {
      "type": "default",
      "align": "top",
      "justify": "start",
      "__config__": {
        "span": 24,
        "formId": "kBORGBaIu",
        "layout": "rowFormItem",
        "tagIcon": "row",
        "children": [
          {
            "style": {
              "width": "100%"
            },
            "__slot__": {
              "append": "",
              "suffix": "",
              "prepend": ""
            },
            "disabled": false,
            "readonly": false,
            "clearable": true,
            "__config__": {
              "tag": "el-input",
              "_tag": "a-input",
              "span": 24,
              "label": "水表编号",
              "formId": "keyZbSPKJ",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "input",
              "document": "https://element.eleme.cn/#/zh-CN/component/input",
              "required": true,
              "showItem": true,
              "changeTag": true,
              "renderKey": "keyZbSPKJ1666260429223",
              "showLabel": true,
              "renderItem": true
            },
            "__vModel__": "contacts",
            "placeholder": "请输入水表编号",
            "prefix-icon": "",
            "suffix-icon": "",
            "__readonly__": {
              "span": 1
            },
            "show-word-limit": false
          },
        ],
        "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
        "renderKey": "kBORGBaIu1666260315496",
        "layoutTree": true,
        "componentName": "row_kBORGBaIu"
      }
    },
    {
      "type": "default",
      "align": "top",
      "justify": "start",
      "__config__": {
        "span": 24,
        "formId": "kaxkjJOBS",
        "layout": "rowFormItem",
        "tagIcon": "row",
        "children": [
          {
            "name": "file",
            "accept": "image/*",
            "__slot__": {
              "list-type": true
            },
            "disabled": false,
            "multiple": false,
            "list-type": "text",
            "__config__": {
              "tag": "el-upload",
              "_tag": "a-upload",
              "span": 24,
              "label": "附件",
              "formId": "kWj3j5msf",
              "layout": "colFormItem",
              "regList": [],
              "tagIcon": "upload",
              "document": "https://element.eleme.cn/#/zh-CN/component/upload",
              "fileSize": 10,
              "required": true,
              "showItem": true,
              "sizeUnit": "MB",
              "changeTag": true,
              "renderKey": "kWj3j5msf1666260452025",
              "showLabel": true,
              "buttonText": "点击上传",
              "notify": '提示： 需上传房主身份证照片、购房合同、开户通知单照片',
              "renderItem": true
            },
            "__vModel__": "annex",
            "buttonText": "",
            "auto-upload": true,
            "placeholder": "请上传附件",
            "__readonly__": {
              "span": 2
            },
            "uploadNumber": 6
          }
        ],
        "document": "https://element.eleme.cn/#/zh-CN/component/layout#row-attributes",
        "renderKey": "kaxkjJOBS1666260316646",
        "layoutTree": true,
        "componentName": "row_kaxkjJOBS"
      }
    }
  ],
  "gutter": 15,
  "formRef": "elForm",
  "disabled": false,
  "formBtns": true,
  "readonly": false,
  "formModel": "formData",
  "formRules": "rules",
  "labelWidth": 100,
  "labelPosition": "right"
}

export { installFormData };